"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Back = function Back(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.188 16.924a.66.66 0 00.664-.66c0-2.76-.82-4.964-2.432-6.548-1.996-1.96-4.64-2.412-5.868-2.512v-3.5a.662.662 0 00-1.128-.468L2.6 9.06a.66.66 0 00-.192.468c0 .176.072.344.192.468l5.52 5.52a.662.662 0 001.128-.468v-3.34c5.448.324 7.248 4.612 7.324 4.804a.665.665 0 00.616.412zm-8.28-8.428c.196 0 3.428.036 5.592 2.172.8.788 1.364 1.772 1.692 2.944-1.396-1.536-3.804-3.244-7.608-3.244a.66.66 0 00-.66.66v2.424l-3.92-3.92 4.22-4.228v2.532c0 .176.072.348.196.472.128.124.348.168.476.192 0-.004.004-.004.012-.004z",
    fill: color
  }));
};
var _default = exports["default"] = Back;